module.exports = __webpack_public_path__ + "static/assets/edabaf21efbdb886455e43629ab5b2f5.png";